import { Text, Title } from '@mantine/core';
import type { FC } from 'react';
import { useHostContext } from '@/context/HostContext.tsx';

type ConfirmationHeaderProps = {
	title: string;
	subtitle?: string;
};

const ConfirmationHeader: FC<ConfirmationHeaderProps> = ({
	title,
	subtitle
}) => {
	const { localization } = useHostContext();

	return (
		<div className="mb-4">
			<span className="inline-block rounded-full bg-slate-100 px-3 py-1 text-xs text-slate-600">
				{localization.translate('creator', 'businessConfirmation.badge')}
			</span>
			<Title
				className="mt-3"
				order={3}
			>
				{title}
			</Title>
			{subtitle ? (
				<Text
					c="dimmed"
					className="mt-1"
					size="sm"
				>
					{subtitle}
				</Text>
			) : null}
		</div>
	);
};

export default ConfirmationHeader;
